import { cn } from '@/lib/utils';

interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Wraps content with a fade-in-up reveal as it scrolls into view.
 *
 * A Server Component that ships zero client JS and, crucially, ships its
 * content **visible**. The reveal is driven entirely by `<ScrollReveal />`
 * (mounted once in the root layout), which observes every `.animated-section`
 * with a single IntersectionObserver.
 *
 * This replaces a Framer Motion `motion.div` per section. At this component's
 * scale that mattered twice over: the homepage alone renders 38 of them, so
 * hydration mounted 38 client components and 38 observers — work that finding
 * seo-h3nbo0 measured holding the LCP image ~1.9s after it had finished
 * downloading — and the server shipped `opacity: 0` on all 38, so nothing
 * below the fold could be seen until hydration completed. Now the markup is
 * visible on arrival and only JS can (briefly) hide what is still off-screen,
 * which is the safe direction for that dependency to run.
 *
 * There is deliberately no `delay` prop. Each section reveals on its own
 * intersection, so a grid cascades from the elements' own scroll positions.
 */
export function AnimatedSection({ children, className }: AnimatedSectionProps) {
  return <div className={cn('animated-section', className)}>{children}</div>;
}
